import { PersonaConfig, PersonaOrder, OrderStatus } from "../types";

// Victoria's Secret — Ava's crew (VOICE_SQUAD_V2). Generated from the seeded demo
// dataset (Victoria Secrets - Demo Data.xlsx) so the picker and the live agent agree:
// if a number here disagrees with what Ava says on the call, that is a real finding.
// The first five are the SCRIPTED demo personas (partial delivery, defective return,
// gifting, delivered-not-received, cancellation guardrail); the rest are background
// accounts. The live crew reads the same rows from its own Supabase via vs_read/vs_write.
export interface VSCustomer {
  id: string;
  name: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  loyaltyTier: string; // Gold | Silver | Core
  homeZip: string;
  city: string;
  state: string;
  crmNotes: string;
  ordersCount: number;
  demoScenario?: string;
  orders: { orderId: string; product: string; status: string; statusLabel?: string; date?: string }[];
}

export const VS_CUSTOMERS: VSCustomer[] = [
  {
    id: "CUST-0001",
    name: "Maya Chen",
    firstName: "Maya",
    lastName: "Chen",
    email: "maya.chen@example.com",
    phone: "+1-555-010-1001",
    loyaltyTier: "Gold",
    homeZip: "94108",
    city: "San Francisco",
    state: "CA",
    crmNotes:
      "The Maple Room / San Francisco — two items delivered, the Satin Long Pajama Set (Pink M) is backordered. She needs it by Friday; Union Square has the last unit.",
    ordersCount: 3,
    demoScenario: "partial_delivery",
    orders: [
      { orderId: "VS2608091001", product: "DreamLift Lace Demi Bra — Black 34D", status: "delivered", statusLabel: "Delivered", date: "2026-08-09" },
      { orderId: "VS2608091001", product: "Cotton Logo Thong — Pink M ×3", status: "delivered", statusLabel: "Delivered", date: "2026-08-09" },
      { orderId: "VS2608091001", product: "Satin Long Pajama Set — Pink M", status: "delayed", statusLabel: "Backordered", date: "2026-08-09" },
    ],
  },
  {
    id: "CUST-0003",
    name: "Emma Patel",
    firstName: "Emma",
    lastName: "Patel",
    email: "emma.patel@example.com",
    phone: "+1-555-010-1003",
    loyaltyTier: "Gold",
    homeZip: "60611",
    city: "Chicago",
    state: "IL",
    crmNotes:
      "Chicago — DreamLift Lace Demi Bra arrived with a broken clasp, and the app won't surface a return option. Return window open to Sep 13.",
    ordersCount: 1,
    demoScenario: "defective_return",
    orders: [
      { orderId: "VS2608023001", product: "DreamLift Lace Demi Bra — Black 34D", status: "delivered", statusLabel: "Delivered", date: "2026-08-02" },
    ],
  },
  {
    id: "CUST-0002",
    name: "Olivia Brooks",
    firstName: "Olivia",
    lastName: "Brooks",
    email: "olivia.brooks@example.com",
    phone: "+1-555-010-1002",
    loyaltyTier: "Silver",
    homeZip: "10001",
    city: "New York",
    state: "NY",
    crmNotes:
      "New York — wants a birthday gift for her sister: light floral, under $100, must arrive by Saturday, shipped to the sister's address, gift-wrapped.",
    ordersCount: 2,
    demoScenario: "gifting_concierge",
    orders: [
      { orderId: "VS2608112001", product: "Satin Long Pajama Set — Pink M", status: "ready_for_pickup", statusLabel: "Ready for pickup", date: "2026-08-11" },
      { orderId: "VS2608112001", product: "Cotton Logo Thong — Black M", status: "ready_for_pickup", statusLabel: "Ready for pickup", date: "2026-08-11" },
    ],
  },
  {
    id: "CUST-0004",
    name: "Sophia Ramirez",
    firstName: "Sophia",
    lastName: "Ramirez",
    email: "sophia.ramirez@example.com",
    phone: "+1-555-010-1004",
    loyaltyTier: "Gold",
    homeZip: "33131",
    city: "Miami",
    state: "FL",
    crmNotes:
      "Miami — order shows delivered to the front desk on Aug 23, but she can't find it. Already contacted chat support once today.",
    ordersCount: 2,
    demoScenario: "delivered_not_received",
    orders: [
      { orderId: "VS2608084001", product: "Bombshell Eau de Parfum — Bombshell 100ml", status: "delivered", statusLabel: "Delivered", date: "2026-08-08" },
      { orderId: "VS2608084001", product: "Beauty Pouch — Pink One Size", status: "delivered", statusLabel: "Delivered", date: "2026-08-08" },
    ],
  },
  {
    id: "CUST-0005",
    name: "Chloe Williams",
    firstName: "Chloe",
    lastName: "Williams",
    email: "chloe.williams@example.com",
    phone: "+1-555-010-1005",
    loyaltyTier: "Core",
    homeZip: "75225",
    city: "Dallas",
    state: "TX",
    crmNotes:
      "Dallas — placed an order this morning and wants to cancel, but every line is already PICKING in the warehouse (uncancellable).",
    ordersCount: 3,
    demoScenario: "cancellation_denied",
    orders: [
      { orderId: "VS2608135001", product: "Satin Robe — Pink One Size", status: "label_created", statusLabel: "Picking", date: "2026-08-13" },
      { orderId: "VS2608135001", product: "Bombshell Eau de Parfum — Bombshell 50ml", status: "label_created", statusLabel: "Picking", date: "2026-08-13" },
      { orderId: "VS2608135001", product: "Cotton Logo Thong — Black M", status: "label_created", statusLabel: "Picking", date: "2026-08-13" },
    ],
  },
  {
    id: "CUST-0006",
    name: "Ava Johnson",
    firstName: "Ava",
    lastName: "Johnson",
    email: "ava.johnson@example.com",
    phone: "+1-555-011-0006",
    loyaltyTier: "Gold",
    homeZip: "02116",
    city: "Boston",
    state: "MA",
    crmNotes:
      "Boston, MA · Gold member · background customer",
    ordersCount: 7,
    orders: [
      { orderId: "VS2607006001", product: "Modal Lounge Short — Gray S", status: "label_created", statusLabel: "Processing", date: "2026-08-08" },
      { orderId: "VS2607006001", product: "Faux Fur Slipper — Pink M", status: "label_created", statusLabel: "Processing", date: "2026-08-08" },
      { orderId: "VS2607006001", product: "DreamLift Lace Demi Bra — Blush 34D", status: "label_created", statusLabel: "Processing", date: "2026-08-08" },
      { orderId: "VS2608006002", product: "BodySoft Wireless Bra — Black 34C", status: "label_created", statusLabel: "Processing", date: "2026-06-07" },
      { orderId: "VS2608006002", product: "Satin Long Pajama Set — Pink M", status: "label_created", statusLabel: "Processing", date: "2026-06-07" },
      { orderId: "VS2608006002", product: "Modal Lounge Short — Pink M", status: "label_created", statusLabel: "Processing", date: "2026-06-07" },
      { orderId: "VS2608006002", product: "FlexFit Sports Bra — Black S", status: "label_created", statusLabel: "Processing", date: "2026-06-07" },
    ],
  },
  {
    id: "CUST-0007",
    name: "Isabella Martinez",
    firstName: "Isabella",
    lastName: "Martinez",
    email: "isabella.martinez@example.com",
    phone: "+1-555-011-0007",
    loyaltyTier: "Core",
    homeZip: "90067",
    city: "Los Angeles",
    state: "CA",
    crmNotes:
      "Los Angeles, CA · Core member · background customer",
    ordersCount: 4,
    orders: [
      { orderId: "VS2608006003", product: "FlexFit Sports Bra — Black M", status: "delivered", statusLabel: "Delivered", date: "2026-08-11" },
      { orderId: "VS2608006003", product: "DreamLift Lace Demi Bra — Black 34C", status: "delivered", statusLabel: "Delivered", date: "2026-08-11" },
      { orderId: "VS2608006003", product: "BodySoft Wireless Bra — Black 34C", status: "delivered", statusLabel: "Delivered", date: "2026-08-11" },
      { orderId: "VS2608006003", product: "Bombshell Eau de Parfum — Bombshell 100ml", status: "delivered", statusLabel: "Delivered", date: "2026-08-11" },
    ],
  },
  {
    id: "CUST-0008",
    name: "Mia Thompson",
    firstName: "Mia",
    lastName: "Thompson",
    email: "mia.thompson@example.com",
    phone: "+1-555-011-0008",
    loyaltyTier: "Core",
    homeZip: "98004",
    city: "Bellevue",
    state: "WA",
    crmNotes:
      "Bellevue, WA · Core member · background customer",
    ordersCount: 2,
    orders: [
      { orderId: "VS2606006004", product: "BodySoft Wireless Bra — Nude 34D", status: "in_transit", statusLabel: "Picked_Up", date: "2026-08-04" },
      { orderId: "VS2607006005", product: "Lace Slip — Black M", status: "delivered", statusLabel: "Delivered", date: "2026-06-11" },
    ],
  },
  {
    id: "CUST-0009",
    name: "Amelia Davis",
    firstName: "Amelia",
    lastName: "Davis",
    email: "amelia.davis@example.com",
    phone: "+1-555-011-0009",
    loyaltyTier: "Core",
    homeZip: "30326",
    city: "Atlanta",
    state: "GA",
    crmNotes:
      "Atlanta, GA · Core member · background customer",
    ordersCount: 2,
    orders: [
      { orderId: "VS2606006006", product: "Studio Legging — Black M", status: "delivered", statusLabel: "Delivered", date: "2026-06-18" },
      { orderId: "VS2606006006", product: "Satin Long Pajama Set — Pink M", status: "delivered", statusLabel: "Delivered", date: "2026-06-18" },
    ],
  },
  {
    id: "CUST-0010",
    name: "Harper Wilson",
    firstName: "Harper",
    lastName: "Wilson",
    email: "harper.wilson@example.com",
    phone: "+1-555-011-0010",
    loyaltyTier: "Gold",
    homeZip: "10012",
    city: "New York",
    state: "NY",
    crmNotes:
      "New York, NY · Gold member · background customer",
    ordersCount: 10,
    orders: [
      { orderId: "VS2606006007", product: "Satin Robe — Pink One Size", status: "delivered", statusLabel: "Delivered", date: "2026-06-08" },
      { orderId: "VS2606006007", product: "Modal Lounge Short — Pink M", status: "delivered", statusLabel: "Delivered", date: "2026-06-08" },
      { orderId: "VS2606006007", product: "Ribbed Tank — White M", status: "delivered", statusLabel: "Delivered", date: "2026-06-08" },
      { orderId: "VS2607006008", product: "Studio Legging — Black M", status: "in_transit", statusLabel: "Preparing", date: "2026-06-01" },
      { orderId: "VS2607006008", product: "Satin Robe — Pink One Size", status: "in_transit", statusLabel: "Preparing", date: "2026-06-01" },
      { orderId: "VS2607006008", product: "DreamLift Lace Demi Bra — Black 36C", status: "in_transit", statusLabel: "Preparing", date: "2026-06-01" },
      { orderId: "VS2607006008", product: "Satin Long Pajama Set — Pink M", status: "in_transit", statusLabel: "Preparing", date: "2026-06-01" },
      { orderId: "VS2606006009", product: "Ribbed Tank — White M", status: "in_transit", statusLabel: "Preparing", date: "2026-06-11" },
      { orderId: "VS2606006009", product: "Faux Fur Slipper — Pink M", status: "in_transit", statusLabel: "Preparing", date: "2026-06-11" },
      { orderId: "VS2606006009", product: "DreamLift Lace Demi Bra — Black 34C", status: "in_transit", statusLabel: "Preparing", date: "2026-06-11" },
    ],
  },
  {
    id: "CUST-0011",
    name: "Evelyn Garcia",
    firstName: "Evelyn",
    lastName: "Garcia",
    email: "evelyn.garcia@example.com",
    phone: "+1-555-011-0011",
    loyaltyTier: "Silver",
    homeZip: "94108",
    city: "San Francisco",
    state: "CA",
    crmNotes:
      "San Francisco, CA · Silver member · background customer",
    ordersCount: 2,
    orders: [
      { orderId: "VS2608006010", product: "DreamLift Lace Demi Bra — Blush 34D", status: "label_created", statusLabel: "Processing", date: "2026-07-02" },
      { orderId: "VS2608006011", product: "Modal Lounge Short — Gray M", status: "delivered", statusLabel: "Delivered", date: "2026-07-26" },
    ],
  },
  {
    id: "CUST-0012",
    name: "Luna Anderson",
    firstName: "Luna",
    lastName: "Anderson",
    email: "luna.anderson@example.com",
    phone: "+1-555-011-0012",
    loyaltyTier: "Core",
    homeZip: "60611",
    city: "Chicago",
    state: "IL",
    crmNotes:
      "Chicago, IL · Core member · background customer",
    ordersCount: 1,
    orders: [
      { orderId: "VS2608006012", product: "Modal Lounge Short — Gray M", status: "ready_for_pickup", statusLabel: "Ready for pickup", date: "2026-07-02" },
    ],
  },
  {
    id: "CUST-0013",
    name: "Camila Taylor",
    firstName: "Camila",
    lastName: "Taylor",
    email: "camila.taylor@example.com",
    phone: "+1-555-011-0013",
    loyaltyTier: "Silver",
    homeZip: "75225",
    city: "Dallas",
    state: "TX",
    crmNotes:
      "Dallas, TX · Silver member · background customer",
    ordersCount: 5,
    orders: [
      { orderId: "VS2608006013", product: "DreamLift Lace Demi Bra — Blush 34D", status: "ready_for_pickup", statusLabel: "Ready for pickup", date: "2026-07-13" },
      { orderId: "VS2608006013", product: "Modal Lounge Short — Gray S", status: "ready_for_pickup", statusLabel: "Ready for pickup", date: "2026-07-13" },
      { orderId: "VS2607006014", product: "Perfume Sampler Set — Pink One Size", status: "delivered", statusLabel: "Delivered", date: "2026-07-26" },
      { orderId: "VS2608006015", product: "Cotton Logo Thong — Black L", status: "in_transit", statusLabel: "Picked_Up", date: "2026-07-03" },
      { orderId: "VS2608006015", product: "Modal Lounge Short — Pink M", status: "in_transit", statusLabel: "Picked_Up", date: "2026-07-03" },
    ],
  },
  {
    id: "CUST-0014",
    name: "Sofia Moore",
    firstName: "Sofia",
    lastName: "Moore",
    email: "sofia.moore@example.com",
    phone: "+1-555-011-0014",
    loyaltyTier: "Core",
    homeZip: "33131",
    city: "Miami",
    state: "FL",
    crmNotes:
      "Miami, FL · Core member · background customer",
    ordersCount: 3,
    orders: [
      { orderId: "VS2607006016", product: "Beauty Pouch — Pink One Size", status: "in_transit", statusLabel: "Preparing", date: "2026-08-10" },
      { orderId: "VS2607006017", product: "Ribbed Tank — Black M", status: "delivered", statusLabel: "Delivered", date: "2026-08-10" },
      { orderId: "VS2607006017", product: "DreamLift Lace Demi Bra — Black 34C", status: "delivered", statusLabel: "Delivered", date: "2026-08-10" },
    ],
  },
  {
    id: "CUST-0015",
    name: "Aria Thomas",
    firstName: "Aria",
    lastName: "Thomas",
    email: "aria.thomas@example.com",
    phone: "+1-555-011-0015",
    loyaltyTier: "Gold",
    homeZip: "02116",
    city: "Boston",
    state: "MA",
    crmNotes:
      "Boston, MA · Gold member · background customer",
    ordersCount: 2,
    orders: [
      { orderId: "VS2607006018", product: "Lace Cami Top — White M", status: "delivered", statusLabel: "Delivered", date: "2026-06-14" },
      { orderId: "VS2607006018", product: "Seamless Cheeky — Black M", status: "delivered", statusLabel: "Delivered", date: "2026-06-14" },
    ],
  },
  {
    id: "CUST-0016",
    name: "Scarlett Jackson",
    firstName: "Scarlett",
    lastName: "Jackson",
    email: "scarlett.jackson@example.com",
    phone: "+1-555-011-0016",
    loyaltyTier: "Core",
    homeZip: "90067",
    city: "Los Angeles",
    state: "CA",
    crmNotes:
      "Los Angeles, CA · Core member · background customer",
    ordersCount: 11,
    orders: [
      { orderId: "VS2608006019", product: "DreamLift Lace Demi Bra — Blush 34D", status: "in_transit", statusLabel: "Picked_Up", date: "2026-07-09" },
      { orderId: "VS2608006019", product: "DreamLift Lace Demi Bra — Black 36C", status: "in_transit", statusLabel: "Picked_Up", date: "2026-07-09" },
      { orderId: "VS2608006019", product: "BodySoft Wireless Bra — Black 34C", status: "in_transit", statusLabel: "Picked_Up", date: "2026-07-09" },
      { orderId: "VS2607006020", product: "Studio Legging — Black S", status: "delivered", statusLabel: "Delivered", date: "2026-08-01" },
      { orderId: "VS2607006020", product: "DreamLift Lace Demi Bra — Black 36C", status: "delivered", statusLabel: "Delivered", date: "2026-08-01" },
      { orderId: "VS2607006020", product: "Satin Long Pajama Set — Pink S", status: "delivered", statusLabel: "Delivered", date: "2026-08-01" },
      { orderId: "VS2607006020", product: "Modal Lounge Short — Gray S", status: "delivered", statusLabel: "Delivered", date: "2026-08-01" },
      { orderId: "VS2607006021", product: "Studio Legging — Black M", status: "label_created", statusLabel: "Processing", date: "2026-07-02" },
      { orderId: "VS2607006021", product: "Satin Long Pajama Set — Black M", status: "label_created", statusLabel: "Processing", date: "2026-07-02" },
      { orderId: "VS2607006021", product: "Card Holder — Red One Size", status: "label_created", statusLabel: "Processing", date: "2026-07-02" },
      { orderId: "VS2607006021", product: "BodySoft Wireless Bra — Black 34C", status: "label_created", statusLabel: "Processing", date: "2026-07-02" },
    ],
  },
  {
    id: "CUST-0017",
    name: "Layla White",
    firstName: "Layla",
    lastName: "White",
    email: "layla.white@example.com",
    phone: "+1-555-011-0017",
    loyaltyTier: "Core",
    homeZip: "98004",
    city: "Bellevue",
    state: "WA",
    crmNotes:
      "Bellevue, WA · Core member · background customer",
    ordersCount: 6,
    orders: [
      { orderId: "VS2607006022", product: "Card Holder — Red One Size", status: "delivered", statusLabel: "Delivered", date: "2026-06-12" },
      { orderId: "VS2607006022", product: "Bombshell Eau de Parfum — Bombshell 50ml", status: "delivered", statusLabel: "Delivered", date: "2026-06-12" },
      { orderId: "VS2607006022", product: "DreamLift Lace Demi Bra — Black 36D", status: "delivered", statusLabel: "Delivered", date: "2026-06-12" },
      { orderId: "VS2607006023", product: "BodySoft Wireless Bra — Nude 34D", status: "in_transit", statusLabel: "Shipped", date: "2026-08-11" },
      { orderId: "VS2607006023", product: "Faux Fur Slipper — Black L", status: "in_transit", statusLabel: "Shipped", date: "2026-08-11" },
      { orderId: "VS2607006023", product: "DreamLift Lace Demi Bra — Black 36D", status: "in_transit", statusLabel: "Shipped", date: "2026-08-11" },
    ],
  },
  {
    id: "CUST-0018",
    name: "Grace Harris",
    firstName: "Grace",
    lastName: "Harris",
    email: "grace.harris@example.com",
    phone: "+1-555-011-0018",
    loyaltyTier: "Gold",
    homeZip: "30326",
    city: "Atlanta",
    state: "GA",
    crmNotes:
      "Atlanta, GA · Gold member · background customer",
    ordersCount: 2,
    orders: [
      { orderId: "VS2607006024", product: "Studio Legging — Black M", status: "delivered", statusLabel: "Delivered", date: "2026-06-17" },
      { orderId: "VS2607006024", product: "DreamLift Lace Demi Bra — Black 34D", status: "delivered", statusLabel: "Delivered", date: "2026-06-17" },
    ],
  },
  {
    id: "CUST-0019",
    name: "Nora Martin",
    firstName: "Nora",
    lastName: "Martin",
    email: "nora.martin@example.com",
    phone: "+1-555-011-0019",
    loyaltyTier: "Gold",
    homeZip: "10012",
    city: "New York",
    state: "NY",
    crmNotes:
      "New York, NY · Gold member · background customer",
    ordersCount: 6,
    orders: [
      { orderId: "VS2606006025", product: "Velvet Petals Body Lotion — Velvet Petals 236ml", status: "in_transit", statusLabel: "Preparing", date: "2026-08-07" },
      { orderId: "VS2606006025", product: "Studio Legging — Black S", status: "in_transit", statusLabel: "Preparing", date: "2026-08-07" },
      { orderId: "VS2606006025", product: "Bare Vanilla Body Mist — Bare Vanilla 250ml", status: "in_transit", statusLabel: "Preparing", date: "2026-08-07" },
      { orderId: "VS2607006026", product: "DreamLift Lace Demi Bra — Black 36C", status: "in_transit", statusLabel: "Preparing", date: "2026-06-03" },
      { orderId: "VS2607006026", product: "Cotton Logo Thong — Pink M", status: "in_transit", statusLabel: "Preparing", date: "2026-06-03" },
      { orderId: "VS2607006026", product: "BodySoft Wireless Bra — Black 36D", status: "in_transit", statusLabel: "Preparing", date: "2026-06-03" },
    ],
  },
  {
    id: "CUST-0020",
    name: "Riley Lee",
    firstName: "Riley",
    lastName: "Lee",
    email: "riley.lee@example.com",
    phone: "+1-555-011-0020",
    loyaltyTier: "Silver",
    homeZip: "94108",
    city: "San Francisco",
    state: "CA",
    crmNotes:
      "San Francisco, CA · Silver member · background customer",
    ordersCount: 10,
    orders: [
      { orderId: "VS2607006027", product: "Seamless Cheeky — Black M", status: "in_transit", statusLabel: "Shipped", date: "2026-06-03" },
      { orderId: "VS2607006027", product: "DreamLift Lace Demi Bra — Black 36C", status: "in_transit", statusLabel: "Shipped", date: "2026-06-03" },
      { orderId: "VS2607006027", product: "Modal Lounge Short — Gray M", status: "in_transit", statusLabel: "Shipped", date: "2026-06-03" },
      { orderId: "VS2607006027", product: "BodySoft Wireless Bra — Black 34C", status: "in_transit", statusLabel: "Shipped", date: "2026-06-03" },
      { orderId: "VS2608006028", product: "Studio Legging — Black S", status: "ready_for_pickup", statusLabel: "Ready for pickup", date: "2026-07-04" },
      { orderId: "VS2608006028", product: "Perfume Sampler Set — Pink One Size", status: "ready_for_pickup", statusLabel: "Ready for pickup", date: "2026-07-04" },
      { orderId: "VS2608006028", product: "DreamLift Lace Demi Bra — Blush 34D", status: "ready_for_pickup", statusLabel: "Ready for pickup", date: "2026-07-04" },
      { orderId: "VS2606006029", product: "Seamless Cheeky — Rose M", status: "in_transit", statusLabel: "Shipped", date: "2026-06-01" },
      { orderId: "VS2606006029", product: "Perfume Sampler Set — Pink One Size", status: "in_transit", statusLabel: "Shipped", date: "2026-06-01" },
      { orderId: "VS2606006029", product: "DreamLift Lace Demi Bra — Black 36C", status: "in_transit", statusLabel: "Shipped", date: "2026-06-01" },
    ],
  },
  {
    id: "CUST-0021",
    name: "Zoey Perez",
    firstName: "Zoey",
    lastName: "Perez",
    email: "zoey.perez@example.com",
    phone: "+1-555-011-0021",
    loyaltyTier: "Silver",
    homeZip: "60611",
    city: "Chicago",
    state: "IL",
    crmNotes:
      "Chicago, IL · Silver member · background customer",
    ordersCount: 2,
    orders: [
      { orderId: "VS2607006030", product: "Beauty Pouch — Pink One Size", status: "in_transit", statusLabel: "Picked_Up", date: "2026-06-12" },
      { orderId: "VS2607006030", product: "DreamLift Lace Demi Bra — Black 36D", status: "in_transit", statusLabel: "Picked_Up", date: "2026-06-12" },
    ],
  },
  {
    id: "CUST-0022",
    name: "Hannah Clark",
    firstName: "Hannah",
    lastName: "Clark",
    email: "hannah.clark@example.com",
    phone: "+1-555-011-0022",
    loyaltyTier: "Core",
    homeZip: "75225",
    city: "Dallas",
    state: "TX",
    crmNotes:
      "Dallas, TX · Core member · background customer",
    ordersCount: 4,
    orders: [
      { orderId: "VS2607006031", product: "Modal Lounge Short — Pink M", status: "in_transit", statusLabel: "Preparing", date: "2026-07-14" },
      { orderId: "VS2607006031", product: "Studio Legging — Black M", status: "in_transit", statusLabel: "Preparing", date: "2026-07-14" },
      { orderId: "VS2607006031", product: "Studio Legging — Black S", status: "in_transit", statusLabel: "Preparing", date: "2026-07-14" },
      { orderId: "VS2607006031", product: "Modal Lounge Short — Gray S", status: "in_transit", statusLabel: "Preparing", date: "2026-07-14" },
    ],
  },
  {
    id: "CUST-0023",
    name: "Lily Lewis",
    firstName: "Lily",
    lastName: "Lewis",
    email: "lily.lewis@example.com",
    phone: "+1-555-011-0023",
    loyaltyTier: "Core",
    homeZip: "33131",
    city: "Miami",
    state: "FL",
    crmNotes:
      "Miami, FL · Core member · background customer",
    ordersCount: 5,
    orders: [
      { orderId: "VS2608006032", product: "Studio Legging — Black S", status: "delivered", statusLabel: "Delivered", date: "2026-08-07" },
      { orderId: "VS2608006032", product: "Cotton Logo Thong — Black S", status: "delivered", statusLabel: "Delivered", date: "2026-08-07" },
      { orderId: "VS2608006033", product: "Modal Lounge Short — Pink M", status: "delivered", statusLabel: "Delivered", date: "2026-07-20" },
      { orderId: "VS2608006033", product: "Beauty Pouch — Pink One Size", status: "delivered", statusLabel: "Delivered", date: "2026-07-20" },
      { orderId: "VS2608006033", product: "Bombshell Eau de Parfum — Bombshell 50ml", status: "delivered", statusLabel: "Delivered", date: "2026-07-20" },
    ],
  },
  {
    id: "CUST-0024",
    name: "Victoria Young",
    firstName: "Victoria",
    lastName: "Young",
    email: "victoria.young@example.com",
    phone: "+1-555-011-0024",
    loyaltyTier: "Core",
    homeZip: "02116",
    city: "Boston",
    state: "MA",
    crmNotes:
      "Boston, MA · Core member · background customer",
    ordersCount: 4,
    orders: [
      { orderId: "VS2607006034", product: "BodySoft Wireless Bra — Black 34C", status: "in_transit", statusLabel: "Shipped", date: "2026-07-16" },
      { orderId: "VS2606006035", product: "BodySoft Wireless Bra — Black 36D", status: "delivered", statusLabel: "Delivered", date: "2026-07-13" },
      { orderId: "VS2606006035", product: "Ribbed Tank — Black M", status: "delivered", statusLabel: "Delivered", date: "2026-07-13" },
      { orderId: "VS2606006035", product: "Beauty Pouch — Pink One Size", status: "delivered", statusLabel: "Delivered", date: "2026-07-13" },
    ],
  },
  {
    id: "CUST-0025",
    name: "Natalie Walker",
    firstName: "Natalie",
    lastName: "Walker",
    email: "natalie.walker@example.com",
    phone: "+1-555-011-0025",
    loyaltyTier: "Silver",
    homeZip: "90067",
    city: "Los Angeles",
    state: "CA",
    crmNotes:
      "Los Angeles, CA · Silver member · background customer",
    ordersCount: 2,
    orders: [
      { orderId: "VS2607006036", product: "Lace Slip — Black M", status: "delivered", statusLabel: "Delivered", date: "2026-06-05" },
      { orderId: "VS2607006036", product: "Ribbed Tank — Black M", status: "delivered", statusLabel: "Delivered", date: "2026-06-05" },
    ],
  },
];

export const VS_PERSONA_ID_PREFIX = "vs_";

export function getVsCustomer(id: string): VSCustomer | undefined {
  return VS_CUSTOMERS.find((c) => c.id === id);
}

export function vsCustomerToPersona(c: VSCustomer): PersonaConfig {
  return {
    id: `${VS_PERSONA_ID_PREFIX}${c.id}`,
    name: c.name,
    role: c.crmNotes || "Customer",
    avatarInitials: ((c.firstName[0] ?? "") + (c.lastName[0] ?? "")).toUpperCase(),
    avatarBg: "",
    tagLine: c.crmNotes,
    email: c.email,
    phone: c.phone,
    accountId: c.id,
    memberSince: "",
    loyaltyTier: c.loyaltyTier,
    city: c.city,
    state: c.state,
    orders: c.orders.map((o): PersonaOrder => ({
      orderId: o.orderId,
      product: o.product,
      status: o.status as OrderStatus,
      statusLabel: o.statusLabel,
      date: o.date ?? "",
    })),
    ordersCount: c.ordersCount,
    bestFor: [],
    suggestedQuestions: {},
    crmNotes: c.crmNotes,
  };
}
